import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';  
const SchoolStrength = () => {  
  useEffect(() => {
    document.title = 'School Strength - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>School</li>
                    <li>School Strength</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
                    <div className="row">
                    <div className="table-responsive maintable">
                    <table className="table">
                        <tbody>
                            <tr>
                                <th colspan="6">ST. FRANCIS XAVIER SCHOOL : TALWANDI RANA &nbsp; SCHOOL STRENGTH </th>
                            </tr>
                            <tr>
                                <th><b>Class</b></th>
                                <th><b>Lily</b></th>
                                <th><b>Rose</b></th>
                                <th><b>Tulip</b></th>
                                <th><b>Lotus</b></th>
                                <th><b>Total</b></th>
                            </tr>
                            <tr>
                                <td>NUR</td>
                                <td>7</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>7</td>
                            </tr>
                            <tr>
                                <td>L.K.G</td>
                                <td>12</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>12</td>
                            </tr>
                            <tr>
                                <td>U.K.G</td>
                                <td>44</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>44</td>
                            </tr>
    
    
                            <tr>
                                <td>I</td>
                                <td>33</td>
                                <td>31</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>64</td>
                            </tr>
    
    
                            <tr>
                                <td>II</td>
                                <td>37</td>
                                <td>37</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>74</td>
                            </tr>
    
                            <tr>
                                <td>III</td>
                                <td>29</td>
                                <td>26</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>55</td>
                            </tr>
    
    
                            <tr>
                                <td>IV</td>
                                <td>39</td>
                                <td>41</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>80</td>
                            </tr>
    
                            <tr>
                                <td>V</td>
                                <td>33</td>
                                <td>34</td>
                                <td>31</td>
                                <td>&nbsp;</td>
                                <td>98</td>
                            </tr>
                            <tr>
                                <td>VI</td>
                                <td>42</td>
                                <td>36</td>
                                <td>34</td>
                                <td>&nbsp;</td>
                                <td>112</td>
                            </tr>
    
                            <tr>
                                <td>VII</td>
                                <td>30</td>
                                <td>30</td>
                                <td>30</td>
                                <td>28</td>
                                <td>118</td>
                            </tr>
                            <tr>
                                <td>VIII</td>
                                <td>28</td>
                                <td>27</td>
                                <td>29</td>
                                <td>34</td>
                                <td>118</td>
                            </tr>
                            <tr>
                                <td>IX</td>
                                <td>29</td>
                                <td>32</td>
                                <td>30</td>
                                <td>34</td>
                                <td>125</td>
                            </tr>
                            <tr>
                                <td>X</td>
                                <td>37</td>
                                <td>33</td>
                                <td>36</td>
                                <td>38</td>
                                <td>144</td>
                            </tr>
    
                            <tr>
                                <td>XI-COM</td>
                                <td>36</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>36</td>
                            </tr>
    
    
                            <tr>
                                <td>XI-SCI</td>
                                <td>25</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>25</td>
                            </tr>
    
                            <tr>
                                <td>XI-ARTS</td>
                                <td>16</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>16</td>
                            </tr>
    
                            <tr>
                                <td>XII-COM</td>
                                <td>34</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>34</td>
                            </tr>
    
                            <tr>
                                <td>XII-SCI</td>
                                <td>28</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>28</td>
                            </tr>
    
                            <tr>
                                <td>XII ARTS</td>
                                <td>18</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>18</td>
                            </tr>
    
                            <tr>
                                <td>TOTAL</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>1209</td>
                            </tr> 
                        </tbody>
                    </table>
                </div>
                    </div> 
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default SchoolStrength;
